<template lang="pug">
  v-menu(attach='' bottom='' left='' offset-y='')
    v-btn(slot='activator' flat='' style='min-width: 48px')
      v-icon(v-if='languages.findIndex(local => local.locale === currentLanguage.locale) < 0') language
      v-img(v-else='' :src='require(`@/assets/flags/${currentLanguage.country}.png`)' width='26px')
    v-list(dense='' light='')
      v-list-tile(v-for='language in languages' :key='language.locale' avatar='' @click='translateI18n(language)')
        v-list-tile-avatar(tile='' size='24px')
          v-icon(v-if="language.locale === 'eo-UY'") language
          v-img(v-else='' :src='require(`@/assets/flags/${language.country}.png`)' width='24px')
        v-list-tile-title(v-text='language.name')
</template>

<script>
// Utilities
import languages from '@/i18n/languages.json'

export default {
  data: () => ({
    languages
  }),
  computed: {
    currentLanguage () {
      const locale = this.$i18n.locale
      return this.languages.find(l => l.alternate === locale || l.locale === locale)
    }
  },
  methods: {
    translateI18n (lang) {
      this.$i18n.locale = lang.locale
      localStorage.setItem('lang', lang.locale)
      // lang = lang.alternate || lang.locale
      // If we're switching in or out of translating
      // then we need to force a reload to make sure
      // that crowdin script is loaded (or unloaded)
      // if (lang === 'eo-UY' || this.$i18n.locale === 'eo-UY') {
      //   setTimeout(() => {
      //     this.$router.go()
      //   }, 1000)
      // }
      // this.$router.replace({ params: { lang } })
      // document.cookie = `currentLanguage=${lang};path=/;max-age=${60 * 60 * 24 * 7}` // expires in 7 days
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ultra-fetal/core/Locales.vue